import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { IRetrieveCartResponse } from '../interfaces/cartApiResponse';

@Injectable({ providedIn: 'root' })
export class CartChangeService {
  private cartChangedSource = new Subject<IRetrieveCartResponse | null>();
  cartChanged$ = this.cartChangedSource.asObservable();

  notifyCartChanged(cart: IRetrieveCartResponse | null) {
    this.cartChangedSource.next(cart);
  }

  private cartEmptiedSource = new BehaviorSubject<void>(undefined);
  cartEmptied$ = this.cartEmptiedSource.asObservable();

  notifyCartEmptied() {
    this.cartEmptiedSource.next();
  }
}
